/* eslint-disable prettier/prettier */
import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

// cache the response for 5 minutes
const DEFAULT_MAXAGE = 300;
export function createCachedGetServerSideProps<T>(
  getServerSideProps: (context: GetServerSidePropsContext) => Promise<T>,
  options?: { maxage?: number },
) {
  return async (
    context: GetServerSidePropsContext,
  ): Promise<GetServerSidePropsResult<T>> => {
    const { res } = context;
    const maxAge = options?.maxage ?? DEFAULT_MAXAGE;
    res.setHeader(
      'Cache-Control',
      `public, s-maxage=${maxAge}, stale-while-revalidate=${maxAge * 5}`,
    );

    const props = await getServerSideProps(context);

    return { props };
  };
}

export function getRouterParams({
  nextPathname,
  pathname,
}: {
  nextPathname: string;
  pathname: string;
}) {
  const paramKeys = Array.from(nextPathname.matchAll(/\[([^[\]]+)\]/gi)).map(
    (match) => {
      const [, paramKey] = match;
      return paramKey;
    },
  );
  const paramValues =
    new RegExp(
      paramKeys.reduce(
        (current, key) => current.replace(`[${key}]`, '(.+)'),
        nextPathname,
      ),
      // eslint-disable-next-line spellcheck/spell-checker
      'gi',
    )
      .exec(pathname)
      ?.slice(1) || [];

  return paramKeys.reduce(
    (current, key, index) => {
      const result = { ...current };
      result[key] = paramValues[index];
      return result;
    },
    {} as Record<string, string>,
  );
}
